import styled from '@nobia/zeus-components/lib/styled'
import rem from '@nobia/zeus-components/lib/styled/rem'
import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import StickyUI from 'react-sticky-el'

const Sticky = styled(StickyUI)`
  margin-bottom: ${p => rem(p.offset)};
  z-index: 100;
  div {
    z-index: 100;
  }
`

const StickyHeader = ({ fixedOffset, fixed, children }) => {
  const stickyRef = useRef(null)
  const [stickyOffset, setStickOffset] = useState(0)
  const parsedChildren =
    typeof children === 'function' ? React.createElement(children) : children

  useEffect(() => {
    if (!stickyRef) {
      return
    }
    if (!fixedOffset) {
      setStickOffset(-stickyRef.current.scrollHeight)
    }
  }, [stickyRef])

  return (
    <Sticky disabled={!fixed} offset={stickyOffset}>
      <div ref={stickyRef}>{parsedChildren}</div>
    </Sticky>
  )
}

export const StickyHeaderDefaultProps = {
  fixed: true,
  fixedOffset: true,
}

export const StickyHeaderPropTypes = {
  fixed: PropTypes.bool,
  fixedOffset: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
}

StickyHeader.defaultProps = StickyHeaderDefaultProps

StickyHeader.propTypes = StickyHeaderPropTypes

export default StickyHeader
